import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { isAuthenticated } from './utils/auth';
import Login from './pages/Login';
import BasicLayout from './layouts/BasicLayout';
import AuthGuard from './components/AuthGuard';
import ErrorBoundary from './components/ErrorBoundary';
import UserList from './pages/System/UserList';
import RoleList from './pages/System/RoleList';
import OperationLog from './pages/System/OperationLog';
import BasicData from './pages/Marketing/BasicData';
import YearlyTarget from './pages/Marketing/YearlyTarget';
import TaskDistribution from './pages/Marketing/TaskDistribution';
import PerformanceFill from './pages/Marketing/PerformanceFill';
import SummaryReport from './pages/Marketing/SummaryReport';
import OrderQuery from './pages/Sales/OrderQuery';
import OrderDetail from './pages/Sales/OrderDetail';
import YesterdaySummary from './pages/Sales/YesterdaySummary';
import PurchaseCost from './pages/Purchase/Cost';
import BIScreen from './pages/Dashboard/BIScreen';

function PrivateRoute({ children }) {
  return isAuthenticated() ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <ErrorBoundary>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<PrivateRoute><BasicLayout /></PrivateRoute>}>
        <Route index element={<Navigate to="/dashboard/bi" replace />} />
        <Route path="system/users" element={<AuthGuard path="/system/users"><UserList /></AuthGuard>} />
        <Route path="system/roles" element={<AuthGuard path="/system/roles"><RoleList /></AuthGuard>} />
        <Route path="system/logs" element={<AuthGuard path="/system/logs"><OperationLog /></AuthGuard>} />
        <Route path="marketing/basic" element={<AuthGuard path="/marketing/basic"><BasicData /></AuthGuard>} />
        <Route path="marketing/yearly-target" element={<AuthGuard path="/marketing/yearly-target"><YearlyTarget /></AuthGuard>} />
        <Route path="marketing/tasks" element={<AuthGuard path="/marketing/tasks"><TaskDistribution /></AuthGuard>} />
        <Route path="marketing/performance" element={<AuthGuard path="/marketing/performance"><PerformanceFill /></AuthGuard>} />
        <Route path="marketing/reports" element={<AuthGuard path="/marketing/reports"><SummaryReport /></AuthGuard>} />
        <Route path="sales/orders" element={<AuthGuard path="/sales/orders"><OrderQuery /></AuthGuard>} />
        <Route path="sales/orders/:soId" element={<AuthGuard path="/sales/orders"><OrderDetail /></AuthGuard>} />
        <Route path="sales/yesterday" element={<AuthGuard path="/sales/yesterday"><YesterdaySummary /></AuthGuard>} />
        <Route path="purchase/cost" element={<AuthGuard path="/purchase/cost"><PurchaseCost /></AuthGuard>} />
        <Route path="dashboard/bi" element={<AuthGuard path="/dashboard/bi"><BIScreen /></AuthGuard>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </ErrorBoundary>
  );
}
